import { configureStore } from "@reduxjs/toolkit";
import appSetupReducer from "../redux/appSetupSlice";
import authReducer from "../redux/authSlice";
import categoriesReducer from "../redux/categorySlice";
import formTemplatesReducer from "../redux/formTemplateSlice";
import liveModeReducer from "../redux/liveModeSlice"; // Import the slice
import moduleReducer from "../redux/moduleSlice";
import partsReducer from "../redux/partSlice";
import procedureRevisionReducer from "../redux/procedureRevisionSlice";
import procedureRevisionStatusReducer from "../redux/procedureRevisionStatusSlice";
import procedureTemplatesRulesReducer from "../redux/procedureTemplateRulesSlice";
import productsReducer from "../redux/productSlice";
import projectsReducer from "../redux/projectSlice";
import suggestionReducer from "../redux/suggestionSlice";
import taskReducer from "../redux/taskSlice";
import trainingLogReducer from "../redux/trainingLogSlice";
import typesReducer from "../redux/typeSlice";
import unitSliceReducer from "../redux/unitSlice";
import usersReducer from "../redux/userSlice";
import sectionReducer from "../redux/sectionSlice";
import stepReducer from "../redux/stepSlice";
import projectIdReducer from "../redux/projectIdSlice";
import snackbarReducer from "../redux/snackbarSlice";
import auditTrailReducer from "../redux/auditTrailSlice";
import versionHistoryReducer from "../redux/versionHistorySlice";
import canvasTemplatesReducer from "../redux/canvasTemplatesSlice";
import videoReducer from "../redux/videoSlice";
import previewReducer from "../redux/previewSlice";
import backupsReducer from "../redux/backupSlice";

export const store = configureStore({
  reducer: {
    liveMode: liveModeReducer,
    units: unitSliceReducer,
    auth: authReducer,
    appSetup: appSetupReducer,
    users: usersReducer,
    category: categoriesReducer,
    parts: partsReducer,
    type: typesReducer,
    suggestion: suggestionReducer,
    projects: projectsReducer,
    products: productsReducer,
    trainingLog: trainingLogReducer,
    module: moduleReducer,
    procedureRevision: procedureRevisionReducer,
    procedureRevisionStatus: procedureRevisionStatusReducer,
    formTemplates: formTemplatesReducer,
    procedureTemplateRule: procedureTemplatesRulesReducer,
    task: taskReducer,
    section: sectionReducer,
    step: stepReducer,
    projectId: projectIdReducer,
    snackbar: snackbarReducer,
    audittrail: auditTrailReducer,
    canvasTemplates: canvasTemplatesReducer,
    versionHistory: versionHistoryReducer,
    video: videoReducer,
    preview: previewReducer,
    backups: backupsReducer,
  },
});

// Expose store to window for debugging and cross-component access
if (typeof window !== "undefined") {
  window.__REDUX_STORE__ = store;
}
